<template>
    <div class="mx-auto">
        <b-modal
            ref="modal-receita-diversa"
            id="modal-receita-diversa"
            size="xl"
            :content-class="'shadow ' + getTheme"
            :title="'Requisição n. ' + itemCarregado.numeroRequisicao"
            header-bg-variant="success"
            header-text-variant="white"
            @hidden="close">
            <template #modal-header="{ close }">
                <h5 class="modal-title">{{ 'Requisição n. ' + itemCarregado.numeroRequisicao }}</h5>
                <b-button variant="success" @click="relatorioPDFReceitasDiversas" class="py-0 ml-auto"> <i class="far fa-file-pdf"></i> Imprimir</b-button>
                <button class="close text-white ml-1" @click="close()" aria-label="close">&times;</button>
            </template>
            <b-row>
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <!-- <b-tabs card :active-nav-item-class="getTheme === 'dark' ? 'text-light' : 'text-dark'">
                            <b-tab title="Dados Básicos" active :title-link-class="getTheme === 'dark' ? 'text-white-50' : 'text-black-50'"> -->
                        <b-tabs card active-nav-item-class="text-title-selected">
                            <b-tab title="Dados Básicos" active title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Tipo da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ receitaDiversa.tipoRequisicao }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Data Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.dataCriacao }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Status Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p :style="'color: ' + receitaDiversa.corStatus">{{ receitaDiversa.status }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Forma de Pgto.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.formaPagamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Tipo de Pgto:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.tipoPagamento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Modalidade Pgto:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p> </p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Qtde. Parcelas:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p> </p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Vlr. da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>R$ {{ receitaDiversa.valor | currency }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Percentual Pago:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.percentualPago }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Origem Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.cnj }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Índice de reajuste:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p></p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Setor Emitente:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.setor }}</p>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Observações:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <pre><p class="texto-scroll" v-html="receitaDiversa.observacoes"></p></pre>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="3" md="2">
                                        <label>Docs. Anexados:</label>
                                    </b-col>
                                    <b-col sm="6" md="7">
                                        <span v-for="anexo in receitaDiversa.anexos" :key="anexo.codAnexo">
                                        <p>
                                            <a class="link" @click="obterAnexo(anexo)">
                                                {{ anexo.nomeAnexo }}
                                            </a>
                                            <b-button class="ml-2" v-if="perfilAdministrador"
                                                    variant="outline-warning"
                                                    @click="removerAnexo(anexo)">
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                        </p>
                                        </span>
                                    </b-col>
                                    <b-col sm="3" md="3">
                                        <b-button variant="outline-warning" @click="incluirAnexo" class="float-right"> <i class="fa fa-paperclip fa-flip-horizontal"></i> Anexar Arquivo</b-button>
                                        <b-form-file v-show="false" @input="realizarUpload" ref="incluir-anexo"></b-form-file>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Devedor" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Devedor:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.nome }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>CPF/ CNPJ:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.documento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>E-mail principal:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.email }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Celular:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.telefone }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Endereço:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.logradouro }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Nº:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.numero }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Complemento:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ receitaDiversa.contribuinte.complemento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Cidade:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.municipio != null ? receitaDiversa.contribuinte.municipio.nome : '' }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Estado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.uf != null ? receitaDiversa.contribuinte.uf.nome : '' }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>CEP:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ receitaDiversa.contribuinte.cep }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="12">
                                        <b-button variant="outline-primary" style="float: right;" @click="atualizarCadastro">
                                            <i class="far fa-address-book fa-flip-horizontal icon-button align-middle"></i> Abrir Cadastro do Devedor
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Pagamento(s)" title-link-class="text-title">
                                <b-row sm="12" md="12" class="d-block">
                                    <b-button v-show="!isFormaPagamentoTransferencia && exibirEditar" class="mr-2" variant="outline-secondary" @click="cancelarBoleto" :disabled="requisicaoCancelada()"
                                        title="O botão Cancelar Boleto faz com que sejam cancelados todos os boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos)."
                                    >
                                        <i class="fa fa-trash"></i> Cancelar Boleto
                                    </b-button>
                                    <b-button v-show="!isFormaPagamentoTransferencia && exibirEditar" class="mr-2" variant="outline-primary" @click="gerarBoleto" :disabled="requisicaoCancelada()"
                                        title="O botão Gerar Boleto faz com que sejam cancelados todos os eventuais boletos pendentes vinculados à Requisição (boletos emitidos, não pagos e ainda não vencidos) e gerados novos boletos para todas as parcelas pendentes e para a parcela do mês corrente."
                                    >
                                        <i class="fa fa-file-pdf"></i> Gerar Boleto
                                    </b-button>
                                    <b-button variant="outline-primary" @click="enviarEmail" class="mr-2"
                                        :title="`Enviar ${isFormaPagamentoTransferencia ? '' : 'boleto e'} documentação ao devedor`"
                                    >
                                        <i class="far fa-envelope"></i> Enviar por E-mail
                                    </b-button>
                                    <b-button variant="secondary" v-b-modal.modal-cancelar-diversas :disabled="desabilitarCancelarEditar()" class="float-right"
                                        title="O botão Cancelar a Requisição permite o cancelamento da Requisição gerada cuja situação seja Aguardando Aprovação, Aguardando Validação ou Pendente. No caso de parcelamento com parcelas pagas, utilize o botão Rescindir Parcelamento disponível na aba Pagamento(s)."
                                    >
                                        <i class="fa fa-trash"></i> Cancelar a Requisição
                                    </b-button>
                                    <b-button variant="warning" class="mr-2 float-right" @click="alterarReceitaDiversa" :disabled="desabilitarCancelarEditar()" v-if="exibirEditar"
                                        title="O botão Editar a Requisição permite editar os parâmetros da Requisição gerada cuja situação seja Aguardando Aprovação, Aguardando Validação ou Pendente. Para a Requisição no status Pendente, caso a edição acarrete a alteração do seu valor, da data de vencimento ou do devedor, o boleto anteriormente gerado na sua criação será automaticamente cancelado, bem como emitido novo boleto com os dados corretos ao final da edição."
                                    >
                                        <i class="fa fa-pen"></i> Editar a Requisição
                                    </b-button>
                                </b-row>
                                <b-row class="mt-3 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>{{ getTituloTabela }}</label>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <CompFiltroGrid
                                            ref="compFiltroReceitasDiversas"
                                            compId="popupFiltroReceitasDiversas"
                                            esconderOrdenacao="true"
                                            :filtro="filtro"
                                            @filtrarResultados="filtrarResultados"
                                            @ordenarResultados="ordenarResultados"/>
                                    <b-table
                                            id="pagamentos"
                                            ref="tablePagamentos"
                                            :items="getItensPagamento"
                                            :fields="getFieldsPagamento"
                                            striped
                                            small
                                            responsive="sm"
                                            :busy="false"
                                            show-empty
                                            hover
                                            bordered
                                            sort-icon-left
                                            class="mb-0 col-12 tabelaModal"
                                            head-variant="light">
                                        <div slot="table-busy" class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong> Carregando...</strong>
                                        </div>
                                        <template slot="empty">
                                            <p class="my-auto">Nenhum tipo de pagamento encontrado.</p>
                                        </template>
                                        <template slot="emptyfiltered">
                                            <p class="my-auto">Não há registros que correspondam ao filtro.</p>
                                        </template>
                                        <template v-slot:head(numeroParcela)>
                                            {{ getFieldsPagamento[0].label }} <i class="filter" :class="filtros.numeroParcela ? 'fa fa-filter' : 'filter-empty'" @click="openFilter(getFieldsPagamento[0], $event)"></i>
                                        </template>
                                        <template v-slot:head(codigoBarras)>
                                            {{ getFieldsPagamento[1].label }} <i class="filter" :class="filtros.codigoBarras ? 'fa fa-filter' : 'filter-empty'" @click="openFilter(getFieldsPagamento[1], $event)"></i>
                                        </template>
                                        <template v-slot:head(dataGeracao)>
                                            {{ getFieldsPagamento[2].label }} <i class="filter" :class="filtros.dataGeracao ? 'fa fa-filter' : 'filter-empty'" @click="openFilter(getFieldsPagamento[2], $event)"></i>
                                        </template>
                                        <template v-slot:head(dataVencimento)>
                                            {{ getFieldsPagamento[3].label }} <i class="filter" :class="filtros.dataVencimento ? 'fa fa-filter' : 'filter-empty'" @click="openFilter(getFieldsPagamento[3], $event)"></i>
                                        </template>
                                        <template v-slot:head(dataPagamento)>
                                            {{ getFieldsPagamento[4].label }} <i class="filter" :class="filtros.dataPagamento ? 'fa fa-filter' : 'filter-empty'" @click="openFilter(getFieldsPagamento[4], $event)"></i>
                                        </template>
                                        <template v-slot:head(valor)>
                                            {{ getFieldsPagamento[isFormaPagamentoTransferencia ? 1 : 5].label }} <i v-if="!isFormaPagamentoTransferencia" class="filter" :class="filtros.valor ? 'fa fa-filter' : 'filter-empty'" @click="openFilter(getFieldsPagamento[isFormaPagamentoTransferencia ? 1 : 5], $event)"></i>
                                        </template>
                                        <template v-slot:head(situacao)>
                                            {{ getFieldsPagamento[6].label }} <i class="filter" :class="filtros.situacao ? 'fa fa-filter' : 'filter-empty'" @click="openFilter(getFieldsPagamento[6], $event)"></i>
                                        </template>
                                        <template v-slot:cell(codigoBarras)="{ item }">
                                            <b-link @click="buscarPdfBoleto(item)" target="_blank">{{ item.codigoBarras }}</b-link>
                                        </template>
                                        <template v-slot:cell(valor)="{ item }">
                                            {{ item.valor | currency }}
                                        </template>
                                    </b-table>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary mr-auto" @click=hide()> <i class="fa fa-reply"></i> Voltar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-cancelar-diversas"
                id="modal-cancelar-diversas"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Cancelar a Requisição"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja cancelar a requisição?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cancelar-diversas')"> Não</b-button>
                <b-button variant="primary" @click="cancelarRequisicao"> Sim</b-button>
            </template>
        </b-modal>

        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="loading"
                @salvarDevedor="salvarDevedor"/>

        <ModalEnviarEmail
                ref="modalEnviarEmail"
                :anexos="receitaDiversa.anexos"
                :loading="loading"
                @enviarEmail="enviarEmail"/>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompFiltroGrid from "../../shared/components/CompFiltroGrid"
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import ModalEnviarEmail from "../../shared/components/ModalEnviarEmail";

    export default {
    props: ['loading'],
    components: { CompFiltroGrid, ModalAlterarDevedor, ModalEnviarEmail },
    mixins: [ formatarMixins ],
    data() {
        return {
            updated: false,
            FORMA_PAGAMENTO_TRANSFERENCIA: 'Transferência',
            urlApi: null,
            token: null,
            exibirEditar: false,
            perfilAdministrador: false,
            dados: {
                uf: [],
                municipios: [],
                statusRequisicao: []
            },
            filter: null,
            filterOn: null,
            filtro: {
                key: null,
                valor: null,
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                campoTexto: null,
                campoData: null,
                campoRadio: null,
                campoCheckbox: null,
                listaValores: []
            },
            filtros: {
                numeroParcela: null,
                codigoBarras: null,
                dataGeracao: null,
                dataVencimento: null,
                dataPagamento: null,
                valor: null,
                situacao: null
            },
            parcelasFiltradas: [],
            messageModal: {
                message: null,
                variant: null
            },
            itemCarregado: {
                numeroRequisicao: null
            },
            receitaDiversa: {
                codReceitasDiversas: null,
                tipoRequisicao: null,
                dataCriacao: null,
                status: null,
                corStatus: null,
                formaPagamento: null,
                tipoPagamento: null,
                valor: null,
                quitada: null,
                observacoes: null,
                bloquearBotoesBoletoMesAnterior: null,
                anexos: [],
                contribuinte: {
                    codContribuinte: null,
                    tipoContribuinte: {
                        id: null,
                        nome: null
                    },
                    nome: null,
                    indAtivo: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: {
                        id: null,
                        nome: null
                    },
                    municipio: {
                        codMunicipio: null,
                        nome: null
                    },
                },
                parcelas: [],
            }
        }
    },
    computed: {
        getFieldsPagamento () {
            if (this.receitaDiversa.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA) {
                return [
                    {
                        key: 'dataTransferencia',
                        label: 'Data da Transf.'
                    },
                    {
                        key: 'valor',
                        label: 'Valor'
                    },
                    {
                        key: 'validadoSetor',
                        label: 'Validação GOFS'
                    },
                    {
                        key: 'validadoTesoureiro',
                        label: 'Validação Tesoureiro'
                    },
                    {
                        key: 'status',
                        label: 'Situação'
                    },
                    {},
                    {}
                ]
            } else {
                return [
                    {
                        key: 'numeroParcela',
                        label: 'Parc.'
                    },
                    {
                        key: 'codigoBarras',
                        label: 'Código de Barras'
                    },
                    {
                        key: 'dataGeracao',
                        label: 'Data Geração'
                    },
                    {
                        key: 'dataVencimento',
                        label: 'Data Venc.'
                    },
                    {
                        key: 'dataPagamento',
                        label: 'Data Pgto'
                    },
                    {
                        key: 'valor',
                        label: 'Valor'
                    },
                    {
                        key: 'situacao',
                        label: 'Situação'
                    }
                ]
            }
        },
        getItensPagamento () {
            if (this.receitaDiversa.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA) {
                return [ this.receitaDiversa ]
            } else {
                return this.parcelasFiltradas
            }
        },
        getTheme () {
            return this.$store.getters.getTheme
        },
        getTituloTabela () {
            if (this.receitaDiversa.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA) {
                return 'Transferência:'
            } else {
                return 'Boleto(s) Gerado(s):'
            }
        },
        isFormaPagamentoTransferencia () {
            return this.receitaDiversa.formaPagamento === this.FORMA_PAGAMENTO_TRANSFERENCIA
        }
    },
    methods: {
        async listarStatusRequisicao() {
            axios.get(`${this.urlApi}/v1/pesquisas/listarStatusRequisicao`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.statusRequisicao = response.data
            })
        },
        abrirExtrato(item) {
            this.limparMsgsModal();

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/carregarExtrato/${item.tabelaOrigem}/${item.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.itemCarregado = item;
                this.receitaDiversa = {
                    ...response.data,
                    id: item.id,
                }
                this.limparFiltros()
                this.$refs['modal-receita-diversa'].show();
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        async obterAnexo(anexo) {
            await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
            }).then(response => {
                if(!response.data || response.data == null){
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                    return;
                }

                var a = document.createElement("a");
                a.href = response.data.base64;
                a.download = response.data.nomeArquivo;
                a.click();
            }).catch((error) => {
                this.exibirErro(error)
            });
        },

        async relatorioPDFReceitasDiversas() {
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/exportarReceitasDiversas/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'ReceitaDiversa' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        cancelarBoleto() {
            this.limparMsgsModal();
            let parcela = null;
            for(var i = 0; i < this.receitaDiversa.parcelas.length; i++) {
                if(this.receitaDiversa.parcelas[i].valor == null) {
                    parcela = this.receitaDiversa.parcelas[i];
                }
            }

            if(parcela == null) {
                this.messageModal = {
                    message: 'Não existe parcela para ser cancelada',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            let titularReceita = 0; // TODO - JEFF Verificar qual titual para realizar o cancelamento
            axios.post(`${this.urlApi}/v1/boleto/bancobrasil/cancelamento/cancelar/${titularReceita}/${parcela.codParcela}`, [], {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(() => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Parcela cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        buscarPdfBoleto (item) {
            this.limparMsgsModal()
            this.loading.showLoading()
            axios.get(`${this.urlApi}/v1/pesquisas/boleto/download/${item.codParcela}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if (!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Boleto não encontrado',
                        variant: 'danger'
                    }
                    return
                }

                let blob = new Blob([response.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Boleto' + (item.codigoBarras ? item.codigoBarras : 'boleto') + '.pdf'
                link.click()
            }).catch((error) => {
                this.messageModal = {
                    message: 'Boleto não encontrado',
                    variant: 'danger'
                }
                return
            }).finally(() => {
                this.loading.hideLoading()
            })
        },
        gerarBoleto() {
            this.limparMsgsModal();
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/gerarBoletoReceitasDiversas/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.messageModal = {
                        message: 'Não existe boleto a ser gerado',
                        variant: 'danger'
                    };
                    return;
                }

                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Boleto' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
                this.abrirExtrato(this.itemCarregado);
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        cancelarRequisicao() {
            this.$refs['modal-cancelar-diversas'].hide();

            this.limparMsgsModal();

            if(this.receitaDiversa.status != 'Aguardando Aprovação' &&
                this.receitaDiversa.status != 'Aguardando Validação' &&
                this.receitaDiversa.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser cancelada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/cancelarReceitasDiversas/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                this.abrirExtrato(this.itemCarregado);
                this.updated = true;
                this.messageModal = {
                    message: 'Requisição cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        alterarReceitaDiversa() {
            this.limparMsgsModal();

            if(this.receitaDiversa.status != 'Aguardando Aprovação' &&
                this.receitaDiversa.status != 'Aguardando Validação' &&
                this.receitaDiversa.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser alterada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            this.$store.commit('setReceitaDiversa', this.itemCarregado.id);
            this.$router.push({path: '/receitas-diversas'});
        },
        atualizarCadastro() {
            this.$refs.modalAlterarDevedor.atualizarCadastro(this.receitaDiversa.contribuinte);
        },
        enviarEmail () {
            this.$refs.modalEnviarEmail.abrirModalEnviarEmail(this.receitaDiversa)
        },
        incluirAnexo () {
            this.$refs['incluir-anexo'].$el.childNodes[0].click()
        },
        realizarUpload (arquivo) {
            this.limparMsgsModal()
            let arquivoConvertido = null
            /* if (!arquivo.name.endsWith(".jpeg")
                && !arquivo.name.endsWith(".jpg")
                && !arquivo.name.endsWith(".png")
                && !arquivo.name.endsWith(".pdf")) {
                this.messageModal = {
                    message: 'Formato do arquivo inválido.',
                    variant: 'danger'
                }
            } else */ if ((arquivo.size / 1024) / 1024 > 50.0) {
                this.messageModal = {
                    message: 'O tamanho do arquivo ultrapassa o limite permitido pelo sistema (50Mb)!',
                    variant: 'danger'
                }
            } else {
                var reader = new FileReader()
                reader.onload = function (e) {
                    arquivoConvertido = {
                        nomeArquivo: arquivo.name,
                        base64: e.target.result
                    }
                }
                reader.readAsDataURL(arquivo)
                reader.onloadend = () => this.salvarAnexo(arquivoConvertido)
            }
        },
        salvarAnexo (arquivo) {
            let parametros = {
                id: this.receitaDiversa.id,
                arquivo: arquivo,
                tipoOrigem: this.receitaDiversa.tipoOrigem
            }

            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/incluirAnexo`, parametros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                let codAnexo = ((response) && (response.data)) ? response.data.id : 0
                this.receitaDiversa.anexos.push({
                    codAnexo: codAnexo,
                    nomeAnexo: arquivo.nomeArquivo,
                    base64 : arquivo.base64
                })
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        removerAnexo (arquivo) {
            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/removerAnexo/${arquivo.codAnexo}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                this.receitaDiversa.anexos = this.receitaDiversa.anexos.filter((anexo) => anexo.codAnexo !== arquivo.codAnexo)
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        salvarDevedor(contribuinte) {
            this.receitaDiversa.contribuinte = {
                codContribuinte: contribuinte.codContribuinte,
                nome: contribuinte.nome,
                documento: contribuinte.documento,
                telefone: contribuinte.telefone,
                email: contribuinte.email,
                emailAlternativo1: contribuinte.emailAlternativo1,
                emailAlternativo2: contribuinte.emailAlternativo2,
                cep: contribuinte.cep,
                logradouro: contribuinte.logradouro,
                numero: contribuinte.numero,
                complemento: contribuinte.complemento,
                bairro: contribuinte.bairro,
                uf: contribuinte.uf,
                municipio: contribuinte.municipio
            };
            this.messageModal = {
                message: 'Cadastro do Devedor alterado com sucesso!',
                variant: 'success'
            };
            this.updated = true;
        },
        verificarObrigatoriedade() {
            return !(this.verificarValorVazio(this.contribuinte.nome) ||
                this.verificarValorVazio(this.contribuinte.documento));
        },
        limparMsgsModal() {
            this.messageModal = {
                message: null,
                variant: null
            };
        },
        openFilter (field, event) {
            this.filtro.key = field.key
            this.filtro.filtrarEm = null
            this.filtro.mascara = null
            this.filtro.campoCheckboxId = null

            switch (field.key) {
                case 'numeroParcela':
                    this.filtro.tipo = 'mascara'
                    this.filtro.campoFiltro = field.label
                    this.filtro.mascara = '########'
                    break
                case 'valor':
                    this.filtro.tipo = 'numerico'
                    this.filtro.campoFiltro = field.label
                    break
                case 'dataGeracao':
                case 'dataVencimento':
                case 'dataPagamento':
                    this.filtro.tipo = 'texto'
                    this.filtro.campoFiltro = field.label
                    break
                case 'codigoBarras':
                    this.filtro.tipo = 'texto'
                    this.filtro.campoFiltro = field.label
                    break
                case 'situacao':
                    this.filtro.tipo = 'checkbox'
                    this.filtro.campoFiltro = field.label
                    this.filtro.campoCheckboxId = 'nome'
                    this.filtro.listaValores = this.dados.statusRequisicao
                    break
            }

            this.$refs.compFiltroReceitasDiversas.openCloseFilterPopup(event, true, 220, 200)
        },
        filtrarResultados (limpar) {
            if (limpar) {
                this.filtro.filtrarEm = null
                this.filtro.campoTexto = null
                this.filtro.campoData = null
                this.filtro.campoRadio = null
                this.filtro.campoCheckbox = null
                this.filtro.campoMascara = null
            }
            
            switch (this.filtro.key) {
                case 'numeroParcela':
                    this.filtro.valor = this.filtro.campoMascara
                    break
                case 'codigoBarras':
                case 'valor':
                    this.filtro.valor = this.filtro.campoTexto
                    break
                case 'dataGeracao':
                case 'dataVencimento':
                case 'dataPagamento':
                    this.filtro.valor = this.filtro.campoTexto
                    break
                case 'situacao':
                    this.filtro.valor = this.filtro.campoCheckbox
                    break
            }

            if (this.filtro.valor || this.filtro.filtrarEm != null) {
                this.filtros[this.filtro.key] = {
                    filtrarEm: this.filtro.filtrarEm,
                    tipo: this.filtro.tipo,
                    valor: this.filtro.valor
                }
            } else {
                this.filtros[this.filtro.key] = null
            }

            this.parcelasFiltradas = this.$refs.compFiltroReceitasDiversas.filtrarLocal(this.receitaDiversa.parcelas, this.filtros)
        },
        limparFiltros () {
            this.parcelasFiltradas = this.receitaDiversa.parcelas
            this.filtros = {
                numeroParcela: null,
                codigoBarras: null,
                dataGeracao: null,
                dataVencimento: null,
                dataPagamento: null,
                valor: null,
                situacao: null
            }
        },
        ordenarResultados () {
        },
        close() {
            this.$emit('closeModal', this.updated);
            this.updated = false;
        },
        requisicaoCancelada() {
            return this.receitaDiversa != null && this.receitaDiversa.status == 'Cancelada';
        },
        desabilitarCancelarEditar() {
            return this.receitaDiversa != null && this.receitaDiversa.status != 'Aguardando Aprovação' &&
                this.receitaDiversa.status != 'Aguardando Validação' &&
                this.receitaDiversa.status != 'Pendente';
        }
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        let userData = JSON.parse(this.$store.getters.getUser);
        if (userData.groups) {
            for (let i = 0; i < userData.groups.length; i++) {
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR' || userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                    this.exibirEditar = true;
                }
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                    this.perfilAdministrador = true;
                }
            }
        }

        this.listarStatusRequisicao();
    }
}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

.icon-button {
    font-size: 1.5rem;
}

</style>
